"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const react = require("react");
const useBatcher = require("./useBatcher.cjs");
function useBatchedCallback(fn, options) {
  const batchedFn = useBatcher.useBatcher(fn, options).addItem;
  return react.useCallback((...args) => batchedFn(args[0]), [batchedFn]);
}
exports.useBatchedCallback = useBatchedCallback;
//# sourceMappingURL=useBatchedCallback.cjs.map
